import Button from '../common/Button.js';
import { QrCode } from 'lucide-react';
import { useScanQrModal } from '../../context/ScanQrModalContext.js';
import { useAuth } from '../../context/AuthContext.js';
import { canOpenScanQrModal, canScanQrForDispatch } from '../../utils/networkMode.js';


const ScanQrStatusButton = ({
  variant = 'secondary',
  className = '',
  label = 'Scan QR',
  fullWidth = false,
  mobileIconOnly = false,
  preferStatus = '',
  dispatchOnly = false,
}) => {
  const { user } = useAuth();
  const { openScanQrModal } = useScanQrModal();

  if (dispatchOnly) {
    if (!canScanQrForDispatch(user)) return null;
  } else if (!canOpenScanQrModal(user)) {
    return null;
  }

  const handleClick = () => {
    openScanQrModal({ preferStatus: preferStatus || (dispatchOnly ? 'Dispatched' : '') });
  };

  return (
    <Button
      variant={variant}
      icon={QrCode}
      onClick={handleClick}
      className={className}
      fullWidth={fullWidth}
      mobileIconOnly={mobileIconOnly}
      mobileLabel={label}
    >
      {label}
    </Button>
  );
};

export default ScanQrStatusButton;
